import { Component, OnInit } from '@angular/core';
import { AuthService } from '@app/core/services/auth/auth.service';

declare const $: any;
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
  subRoute: any[];
}
export const ROUTES: RouteInfo[] = [
  {
    path: '/dashboard',
    title: 'Dashboard',
    icon: 'dashboard',
    class: '',
    subRoute: []
  },
  {
    path: '/mapa',
    title: 'Mapa',
    icon: 'location_on',
    class: '',
    subRoute: []
  },
  {
    path: '/mantenimientos',
    title: 'Mantenimientos',
    icon: 'label',
    class: 'separator',
    subRoute: [
      {
        path: '/delivery',
        title: 'Delivery',
        icon: 'motorcycle',
        class: ''
      },
      {
        path: '/sucursales',
        title: 'Sucursales',
        icon: 'store',
        class: ''
      }
    ]
  }
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
  }

  isMobileMenu() {
    if (window.innerWidth > 991) {
      return false;
    }
    return true;
  }

  logOut(): void {
    this.authService.logOut();
  }
}
